// Authentication service - replace with real API calls in production
const tokenVariableName = 'admi_token';
import { api, apiWithoutToken } from './token_handler'
import { useAuthStore } from '@/stores/auth'

export default {

  async isUserAuthenticated() {
    try {
      const response = await api.get('/auth/is-authenticated', {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Sesion Invalida' };
    }
  },

  async login({ email, password }) {
    try {
      const response = await apiWithoutToken.post('/auth/login', { email, password }, {
        withCredentials: true
      });
      localStorage.setItem(tokenVariableName, response.data.accessToken);

      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al iniciar sesión' };
    }
  },

  async revokeRefreshToken() {
      return await api.post('/auth/logout', {}, {
        withCredentials: true
      });
  },

  async deleteSessionToken() {
    localStorage.removeItem(tokenVariableName);
    const authStore = useAuthStore();
    authStore.token = null;
  },

  async changePassword({ currentPassword, newPassword }) {
    try {
      const response = await api.post('/auth/change-password', { currentPassword, newPassword });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al cambiar la contraseña' };
    }
  },

  async forgotPassword(email) {
    try {
      const response = await apiWithoutToken.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al restablecer la contraseña' };
    }
  },

  async resetPassword(token, newPassword) {
    try {
      const response = await apiWithoutToken.post('/auth/reset-password', { token, password: newPassword });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al restablecer la contraseña' };
    }
  }
};
  